exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail-table[data-v-6b68b5c5]{margin-top:10px}", ""]);

// exports
